import React from "react";
import PageTitle from "components/v1/PageTitle";
import useUrlSearchParamsState from "hooks/useUrlSearchParamsState";
import CoverageDetailsTabs from "./CoverageDetailsTabs";
import CoverageDetailsProductDetail from "./CoverageDetailsProductDetail";
import { getCompanyName } from "utlis/utils";

function CoverageDetails({ products, showClaims }) {
  const companyName = getCompanyName();
  const defaultProduct = companyName === "ANTHEA PHARMA PRIVATE LIMITED" ? "parental_cover" : "health_insurance";

  const [activeProduct, setActiveProduct] = useUrlSearchParamsState(
    "tab",
    defaultProduct
  );

  return (
    <section style={{ width: "100%", maxWidth: "100%", boxSizing: "border-box" }}>
      <PageTitle title="Coverage Details" />
      <section
        style={{
          marginTop: "28px",
          width: "100%",
          maxWidth: "100%",
          boxSizing: "border-box",
        }}
      >
        <CoverageDetailsTabs
          activeProduct={activeProduct}
          setActiveProduct={setActiveProduct}
          products={products}
        />
        <CoverageDetailsProductDetail
          showClaims={showClaims}
          activeProduct={activeProduct}
          products={products}
        />
      </section>
    </section>
  );
}

export default CoverageDetails;
